/**
 * @desc 后台管理角色保存
 */
import { OperationRoleForm } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type CreateOperationRoleParameter = OperationRoleForm

const method = 'POST'
const url = '/auth/operation/role'

export const createOperationRoleApi = (
  data?: CreateOperationRoleParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

createOperationRoleApi.method = method
createOperationRoleApi.url = url
